/**
 * Resolves theme image files to hashed, cached, bundler-managed URLs.
 *
 * Theme images live in `src/assets/themes/` as flat `t1.webp … t12.webp`. We use
 * a single `import.meta.glob` (eager, `?url`) rather than individual imports:
 *  - it returns the HASHED url string for every file that actually exists, so a
 *    missing `tN.webp` simply isn't in the map (→ we can flag it, never fake it);
 *  - `?url` imports only the path string, NOT the image bytes — the browser
 *    fetches a given `tN.webp` only when something references its url (the active
 *    background, or a thumbnail that scrolls into view). Nothing is loaded upfront.
 */
const FILES = import.meta.glob('../../assets/themes/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

/** Hashed url for theme file `tN`, or null if that file isn't in the repo. */
export function themeAssetUrl(file: number | null | undefined): string | null {
  if (file == null) return null;
  const entry = Object.entries(FILES).find(([path]) => path.endsWith(`/t${file}.webp`));
  return entry ? entry[1] : null;
}

/** Whether `tN.webp` is present in the bundle. */
export function themeAssetExists(file: number | null | undefined): boolean {
  return themeAssetUrl(file) != null;
}
